export const ADD_CANDIDATE_INFO = "ADD_CANDIDATE_INFO";
export const ADD_BASIC_INFO = "ADD_BASIC_INFO";

export const RESET_REGISTER = "RESET_REGISTER";

export const addCandidateInfo = (data) => {
  return {
    type: ADD_CANDIDATE_INFO,
    data,
  };
};
export const resetRegister = () => {
  return {
    type: RESET_REGISTER,
  };
};

export const addBasicInfo = (data) => {
  return {
    type: ADD_BASIC_INFO,
    data,
  };
};
